// extracted by mini-css-extract-plugin
module.exports = {"root":"TextArea_root__asQda","error":"TextArea_error__y_Bgf"};